import { getIQConfigSettings } from '@/constants/forms-api.const';
import { RequestServices as _http } from '../common/request.services';
import { IConfig } from '@/interfaces/common/config.interface';

export const IQConfigSettingsServices = {
  /**
   * Get IQ config settings from sitecore 10
   * @returns
   */
  getIQConfigSettings(): Promise<IConfig[]> {
    return _http.HttpGet(`${getIQConfigSettings}`);
  },
} as const;
